import React from 'react';
import Label from 'components/form/Label/Label';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { TitleContainer } from 'components/Containers/TitleContainer/TitleContainer';
import HomeLoanFilter from '../HomeLoanFilter';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import { DetailedHomeLoanOffer } from 'components/Offers/DetailedHomeLoanOffer';
import ZeroState from 'components/ZeroState';

const OfferArea = props => {
  if (props.loading) {
    return <PageLoadingMask />;
  } else if (
    !props.mortgageOffers ||
    props.mortgageOffers?.items?.length === 0
  ) {
    return (
      <>
        <Row>
          <TitleContainer type="pageTitle">
            <Label
              datatestid={props.datatestid + '-body-title'}
              type="H3"
              typeHeader={'h3'}
            >
              0 Mortgage
            </Label>
          </TitleContainer>
        </Row>
        <ZeroState
          title="No results found"
          description="Try adjusting your filter to find what you're looking for."
        />
      </>
    );
  } else {
    return (
      <Row>
        <StaticOfferContainer
          datatestid={props.datatestid}
          pagePosition={props.pagePosition}
          offerMetadataList={props.mortgageOffers.items || props.mortgageOffers}
          eventHandler={props.eventHandler}
          modulePosition={props.modulePosition}
          homeLoanTemplate={props.homeLoanTemplate}
        />
      </Row>
    );
  }
};
const HomeLoanOffersView = ({
  datatestid,
  mortgageOffers,
  eventHandler,
  activeTab,
  ...props
}) => {
  if ((!props.defaultLoanAmount || !props.loanAmount) && !props.isOcfPage) {
    return <PageLoadingMask />;
  } else {
    return (
      <SectionContainer className="homeLoanOffersContainer">
        <Row>
          <TitleContainer>
            <Label type="H3" typeHeader={'h3'} className={'marg0'}>
              {props.offerMessage}
            </Label>
          </TitleContainer>
        </Row>
        <>
          <Row>
            <HomeLoanFilter
              mortgageOffers={mortgageOffers}
              showModal={props.commonStates.showModal}
              {...props}
            />
          </Row>
        </>
        <OfferArea
          loading={props.homeLoanOffersLoading}
          {...props}
          homeLoanTemplate={DetailedHomeLoanOffer}
          modulePosition={props.modulePosition}
          mortgageOffers={mortgageOffers}
          eventHandler={eventHandler}
          pagePosition={props.pagePosition}
        />
        {mortgageOffers?.metadata?.bankrateNMLS?.length && (
          <Row>
            <Label className="text-12">
              {mortgageOffers?.metadata?.bankrateNMLS[0]} |{' '}
              <a
                href={props?.config?.nmlsConsumerAccess?.bankrateLLC}
                target="_blank"
                rel="noreferrer"
              >
                NMLS Consumer Access
              </a>
            </Label>
            <Label className="text-12">
              {mortgageOffers?.metadata?.bankrateNMLS[1]} |{' '}
              <a
                href={props?.config?.nmlsConsumerAccess?.brTechServices}
                target="_blank"
                rel="noreferrer"
              >
                NMLS Consumer Access
              </a>
            </Label>
          </Row>
        )}
      </SectionContainer>
    );
  }
};

export default HomeLoanOffersView;
